// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__35Vnf","content":"GlobalSearch_content__SgKxx"};